import React, { Component } from 'react'
import { cdnDomain } from '../utilities/config'
import { vehicleImageHelpers } from '../utilities/vehicleImageHelpers'
const VehicleImageShadow = `${cdnDomain}/static/images/shadowVehicle.png`

class VehicleMakeModelImage extends Component {
  
  constructor(props){
    super(props)
    this.state = {
      vehicleImageUrl: ''
    }
  }

  componentDidMount = () => {
    vehicleImageHelpers.getStockImage.call(this)
  }

  render = () => {
    const { size, image, isImgPadded } = this.props
    const { vehicleImageUrl } = this.state

    return(
      <div className={`vehicle-make-model-image-wrapper ${isImgPadded ? 'vehicle-make-model-image-wrapper--is-padded' : ''}`}>
        <img className={`vehicle-make-model-image ${size ? `vehicle-make-model-image--is-${size}` : '' }`} src={image || vehicleImageUrl || VehicleImageShadow} alt="" />
      </div>
    )
  }
}

export default VehicleMakeModelImage